import { configureStore } from "@reduxjs/toolkit";
import user from "@/models/user";
import config from "@/models/config";

export const store = configureStore({
  reducer: {
    user,
    config,
  },
});
